// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltipStyle_tooltip__wzmwS","arrow":"tooltipStyle_arrow__PAUbp","textElem":"tooltipStyle_textElem__pxzKS"};